import React from 'react';

const wrapperStyles =
  window.innerWidth < 992 ? { padding: '0 1.5rem' } : { paddingRight: '2rem' };

const TermsContents = () => (
  <div style={wrapperStyles} className={'lakes-medium'}>
    <p>
      SuiteDeals include Federal Excise Tax of 7.5%. Availability of SuiteDeals
      is extremely limited, and may change after they are posted. SuiteDeals are
      100% non-refundable and cannot be cancelled or changed.
    </p>
    <p>
      <span className={'lakes-bold'}>Change Of Route By JetSuite:</span>{' '}
      SuiteDeals may experience a last minute change or cancellation, due to
      operational demand or a Client request. Should a SuiteDeal be changed
      post-purchase, the Customer will have the option to either fly the new
      route if operationally possible or shall receive 100% of the paid fare
      amount in a form of a credit to the credit card account which was used to
      purchase the seat(s).
    </p>
    <p>
      <span className={'lakes-bold'}>Liability:</span> Customer acknowledges
      JetSuite has no liability whatsoever for direct or inconsequential damage
      as a result of a delay or cancellation of the Customer's flight.
    </p>
    <p>
      <span className={'lakes-bold'}>Cancellation By JetSuite:</span> In the
      event the flight is cancelled by JetSuite, the Customer shall receive 100%
      of the paid fare amount in a form of a credit to the credit card account
      which was used to purchase the seat(s). The decision to cancel a flight
      will be at JetSuite's sole discretion and in the event JetSuite shall
      incur no liability other than the full refund of the fare paid.
    </p>
    <p>
      <span className={'lakes-bold'}>Late Passenger Arrival:</span> All
      passengers must arrive 15 minutes prior to the agreed departure time of
      the flight. Failure to arrive within this timeframe will subject the
      flight to cancellation at JetSuite's sole discretion.
    </p>
    <p>
      <span className={'lakes-bold'}>Change Of Departure Time:</span> Departure
      time of flight cannot be changed.
    </p>
    <p>
      <span className={'lakes-bold'}>Name Changes: </span>
      Name changes are not allowed.
    </p>
    <p>
      <span className={'lakes-bold'}>Additional Passengers:</span> Only
      Customers whose names appear on the confirmation may travel on the flight.
      Individuals whose names do not appear on the confirmation will be denied
      access to the aircraft.
    </p>
    <p>
      <span className={'lakes-bold'}>Pet Policy: </span>
      Pets are not allowed on SuiteDeal flights.
    </p>
    <p>
      <span className={'lakes-bold'}>
        Refunds For Customer Cancellation Or No Show:
      </span>{' '}
      No cash refunds in any amount will be granted for any reason at any time.
      The following cancellation penalties apply:
    </p>
    <p>
      <span className={'lakes-bold'}>Additional Charges: </span>
      Customer agrees that JetSuite may charge Customer's credit card for any
      and all damage and excess wear &amp; tear caused to the aircraft by
      Customer during the Customer's flight as determined at JetSuite's sole
      discretion.
    </p>
    <p>
      <span className={'lakes-bold'}>Promo Codes:</span> Customer using a promo
      code agrees that the code is valid for one SuiteDeal trip valued less than
      or equal to $1,095.
    </p>
    <p>
      <span className={'lakes-bold'}>Operational:</span> Smoking in aircraft is
      not permitted. Hazardous materials are not accepted on board or in checked
      baggage. Each Customer 18 years of age or older will be required to show a
      valid government-issued photo ID that must match the name on the
      confirmation. Customers under 18 years of age will not be required to show
      an ID, but their name(s) must appear on the reservation. One lap child per
      flight under the age of 2 is permitted, although weight restrictions may
      apply to any flight.
    </p>
  </div>
);

export default TermsContents;



// WEBPACK FOOTER //
// ./src/components/Legal/TermsAndConditions/TermsContents.jsx